import { createBrowserRouter, type RouteObject } from "react-router-dom";
import { AppShell } from "./layout/AppShell";
import { CompetitionDetails } from "./pages/CompetitionDetails";
import { Home } from "./pages/Home";
import { JoinNow } from "./pages/JoinNow";
import { NotFound } from "./pages/NotFound";
import { RelatedWebsites } from "./pages/RelatedWebsites";
import { TheQuizFinal } from "./pages/TheQuizFinal";
import { TryItNow } from "./pages/TryItNow";

type LocaleKey = "zh-Hant" | "en";

const sharedChildren: RouteObject[] = [
  { index: true, element: <Home /> },
  { path: "competition-details", element: <CompetitionDetails /> },
  { path: "join-now", element: <JoinNow /> },
  { path: "event-details", element: <TheQuizFinal /> },
  { path: "try-it-now", element: <TryItNow /> },
  { path: "related-websites", element: <RelatedWebsites /> },
  { path: "*", element: <NotFound /> },
];

const makeLocaleRoute = (
  path: "/" | "/en",
  locale: LocaleKey,
  localePrefix: "" | "en",
): RouteObject => ({
  path,
  element: <AppShell />,
  handle: { locale, localePrefix },
  children: sharedChildren,
});

export const router = createBrowserRouter(
  [makeLocaleRoute("/", "zh-Hant", ""), makeLocaleRoute("/en", "en", "en")],
  { basename: "/basiclaw2025-26" },
);
